/**
 * Mock premises data for development/testing.
 * This mirrors the exact JSON structure returned by the server POST API.
 * Used when VObjectListing has :use-mock-data="true".
 */

const mockPremisesData = {
  Premises: {
    PremisesFilters: [
      {
        Name: "location",
        DisplayName: "Område",
        Items: [
          {
            Id: "46123",
            Name: "Malmö",
            DisplayName: null,
            Active: false,
            Districts: [
              {
                Id: "46195",
                Name: "Burlöv/Stora Bernstorp",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "126530",
                Name: "Västra hamnen",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "46456",
                Name: "Centrum",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "46757",
                Name: "Dockan/Varvsstaden",
                DisplayName: null,
                Active: true,
              },
              {
                Id: "47059",
                Name: "Fosie/Jägersro",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "47477",
                Name: "Hyllie/Svågertorp",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "47747",
                Name: "Limhamn",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "48012",
                Name: "Norra Sorgenfri",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "48065",
                Name: "Nyhamnen",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "106439",
                Name: "Medeon",
                DisplayName: null,
                Active: false,
              },
            ],
          },
          {
            Id: "46154",
            Name: "Lund",
            DisplayName: null,
            Active: false,
            Districts: [
              {
                Id: "48103",
                Name: "Gastelyckan",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "48157",
                Name: "Ideon",
                DisplayName: null,
                Active: true,
              },
              {
                Id: "48851",
                Name: "Lund centrum",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "126540",
                Name: "Råbyholm",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "107409",
                Name: "Science Village",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "48939",
                Name: "Väster",
                DisplayName: null,
                Active: false,
              },
            ],
          },
          {
            Id: "46173",
            Name: "Helsingborg",
            DisplayName: null,
            Active: false,
            Districts: [
              {
                Id: "50708",
                Name: "Berga",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "49008",
                Name: "Centrum",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "49739",
                Name: "Långeberga",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "49752",
                Name: "Södra",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "50483",
                Name: "Väla södra / Väla norra",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "50579",
                Name: "Ättekulla",
                DisplayName: null,
                Active: false,
              },
              {
                Id: "118847",
                Name: "Landskrona",
                DisplayName: null,
                Active: false,
              },
            ],
          },
        ],
        Selected: null,
      },
      {
        Name: "premisetype",
        DisplayName: "Typ av lokal",
        Items: [
          "Kontor",
          "Industri",
          "Lager",
          "Butik",
          "Kontorshotell",
          "Tomt/Nybyggnation",
        ],
        Selected: null,
      },
      {
        Name: "area",
        DisplayName: "Area",
        MinValue: 0,
        MaxValue: 2147483647,
        AdjustedMax: 2000,
      },
    ],
    Premises: [
      {
        PricePerSqure: null,
        Url: "/sv/lediga-lokaler/malmo/dockan/skrovet-6/isbergs-gata-2-del-av-plan-3-5/",
        Image: {
          SrcSet:
            "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetWebp:
            "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?format=webp&width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetLowQuality: null,
          SrcSetLowQualityWebp: null,
          SizesAttribute:
            "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
          ImgSrc:
            "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
          ImgSrcLowQuality: null,
          AltText: "Werket - framtidens kontor vid porten till Dockan",
        },
        Title: "Werket - framtidens kontor vid porten till Dockan",
        SizeFrom: 660,
        SizeTo: 660,
        City: "Malmö",
        District: "Dockan/Varvsstaden",
        PremiseType: ["Kontor"],
        Address: "Isbergs gata 2",
        SelectedFeatures: [
          { Description: "Balkong", Icon: "outdoor" },
          { Description: "Besöksparkering", Icon: "parking" },
          { Description: "Cykelrum", Icon: "bike" },
          { Description: "Dusch", Icon: "shower" },
        ],
        OverflowFeaturesCount: 11,
        ChangedDate: "2026-01-21 15:33:52",
        Latitude: 55.6129559,
        Longitude: 12.9915251,
        TextRow: "",
        TextRow2: "",
      },
      {
        PricePerSqure: null,
        Url: "/sv/lediga-lokaler/malmo/dockan/skrovet-6/isbergs-gata-2-del-av-plan-3/",
        Image: {
          SrcSet:
            "/contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetWebp:
            "/contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?format=webp&width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetLowQuality: null,
          SrcSetLowQualityWebp: null,
          SizesAttribute:
            "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
          ImgSrc:
            "/contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
          ImgSrcLowQuality: null,
          AltText: "Kontorslokal i Werket ",
        },
        Title: "Kontorslokal i Werket ",
        SizeFrom: 805,
        SizeTo: 805,
        City: "Malmö",
        District: "Dockan/Varvsstaden",
        PremiseType: ["Kontor"],
        Address: "Isbergs gata 2",
        SelectedFeatures: [
          { Description: "Balkong", Icon: "outdoor" },
          { Description: "Cykelrum", Icon: "bike" },
          { Description: "Dusch", Icon: "shower" },
          { Description: "Fiberanslutning", Icon: "fiber" },
        ],
        OverflowFeaturesCount: 10,
        ChangedDate: "2026-01-14 16:03:35",
        Latitude: 55.6129559,
        Longitude: 12.9915251,
        TextRow: "",
        TextRow2: "",
      },
      {
        PricePerSqure: null,
        Url: "/sv/lediga-lokaler/malmo/dockan/kranen-14/isbergsgata-13-del-av-plan-2/",
        Image: {
          SrcSet:
            "/contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetWebp:
            "/contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?format=webp&width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetLowQuality: null,
          SrcSetLowQualityWebp: null,
          SizesAttribute:
            "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
          ImgSrc:
            "/contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
          ImgSrcLowQuality: null,
          AltText: "Kontorslokal i hjärtat av Dockan",
        },
        Title: "Kontorslokal i hjärtat av Dockan",
        SizeFrom: 707,
        SizeTo: 707,
        City: "Malmö",
        District: "Dockan/Varvsstaden",
        PremiseType: ["Kontor"],
        Address: "Isbergs gata 13",
        SelectedFeatures: [
          { Description: "Fiberanslutning", Icon: "fiber" },
          { Description: "Miljöcertifiering", Icon: "award" },
          { Description: "Miljörum", Icon: "recycling" },
          { Description: "Närhet till buss", Icon: "bus" },
        ],
        OverflowFeaturesCount: 3,
        ChangedDate: "2025-07-15 15:30:22",
        Latitude: 55.6139285,
        Longitude: 12.9916056,
        TextRow: "",
        TextRow2: "",
      },
      {
        PricePerSqure: null,
        Url: "/sv/lediga-lokaler/lund/ideon/syret-9/syret-9-4849-00206/",
        Image: {
          SrcSet:
            "/contentassets/917e0297ab8240e7b7dc932e1a020586/syret_9--7.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/917e0297ab8240e7b7dc932e1a020586/syret_9--7.jpg?width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetWebp:
            "/contentassets/917e0297ab8240e7b7dc932e1a020586/syret_9--7.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/917e0297ab8240e7b7dc932e1a020586/syret_9--7.jpg?format=webp&width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetLowQuality: null,
          SrcSetLowQualityWebp: null,
          SizesAttribute:
            "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
          ImgSrc:
            "/contentassets/917e0297ab8240e7b7dc932e1a020586/syret_9--7.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
          ImgSrcLowQuality: null,
          AltText: "Trevligt kontor med labb i hjärtat av Ideon",
        },
        Title: "Trevligt kontor med labb i hjärtat av Ideon",
        SizeFrom: 318,
        SizeTo: 378,
        City: "Lund",
        District: "Ideon",
        PremiseType: ["Kontor"],
        Address: "Ideongatan 3A",
        SelectedFeatures: [
          { Description: "Elbilsplatser", Icon: "charge" },
          { Description: "Fiberanslutning", Icon: "fiber" },
          { Description: "Kök/pentry", Icon: "oven" },
          { Description: "Miljörum", Icon: "recycling" },
        ],
        OverflowFeaturesCount: 8,
        ChangedDate: "2025-02-05 11:23:36",
        Latitude: 55.7154903,
        Longitude: 13.213754,
        TextRow: "",
        TextRow2: "",
      },
      {
        PricePerSqure: null,
        Url: "/sv/lediga-lokaler/lund/ideon/syret-9/syret-9-4849-00109/",
        Image: {
          SrcSet:
            "/contentassets/60c2b2adc6d340df8fc7f1be7cb086ef/ideongatan_3a-20250515-09.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/60c2b2adc6d340df8fc7f1be7cb086ef/ideongatan_3a-20250515-09.jpg?width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetWebp:
            "/contentassets/60c2b2adc6d340df8fc7f1be7cb086ef/ideongatan_3a-20250515-09.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/60c2b2adc6d340df8fc7f1be7cb086ef/ideongatan_3a-20250515-09.jpg?format=webp&width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetLowQuality: null,
          SrcSetLowQualityWebp: null,
          SizesAttribute:
            "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
          ImgSrc:
            "/contentassets/60c2b2adc6d340df8fc7f1be7cb086ef/ideongatan_3a-20250515-09.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
          ImgSrcLowQuality: null,
          AltText: "Stilfull lokal med verkstadsdel och lastintag",
        },
        Title: "Stilfull lokal med verkstadsdel och lastintag",
        SizeFrom: 457,
        SizeTo: 457,
        City: "Lund",
        District: "Ideon",
        PremiseType: ["Kontor", "Industri"],
        Address: "Ideongatan 3a",
        SelectedFeatures: [
          { Description: "Elbilsplatser", Icon: "charge" },
          { Description: "Fiberanslutning", Icon: "fiber" },
          { Description: "Kök/pentry", Icon: "oven" },
          { Description: "Miljörum", Icon: "recycling" },
        ],
        OverflowFeaturesCount: 8,
        ChangedDate: "2025-05-22 14:11:21",
        Latitude: 55.7167148,
        Longitude: 13.2139047,
        TextRow: "",
        TextRow2: "",
      },
      {
        PricePerSqure: null,
        Url: "/sv/lediga-lokaler/lund/ideon/syret-8/4848-00208/",
        Image: {
          SrcSet:
            "/contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetWebp:
            "/contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?format=webp&width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetLowQuality: null,
          SrcSetLowQualityWebp: null,
          SizesAttribute:
            "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
          ImgSrc:
            "/contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
          ImgSrcLowQuality: null,
          AltText: "Nu ger vi dig chansen att forma ditt eget labb ",
        },
        Title: "Nu ger vi dig chansen att forma ditt eget labb ",
        SizeFrom: 403,
        SizeTo: 1438,
        City: "Lund",
        District: "Ideon",
        PremiseType: ["Kontor"],
        Address: "Ideongatan 1A",
        SelectedFeatures: [
          { Description: "Elbilsplatser", Icon: "charge" },
          { Description: "Fiberanslutning", Icon: "fiber" },
          { Description: "Miljöcertifiering", Icon: "award" },
          { Description: "Miljörum", Icon: "recycling" },
        ],
        OverflowFeaturesCount: 2,
        ChangedDate: "2025-11-03 09:18:33",
        Latitude: 55.7160134,
        Longitude: 13.2142949,
        TextRow: "",
        TextRow2: "",
      },
      {
        PricePerSqure: null,
        Url: "/sv/lediga-lokaler/lund/ideon/syret-8/syret-8-4848-00101/",
        Image: {
          SrcSet:
            "/contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetWebp:
            "/contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?format=webp&width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetLowQuality: null,
          SrcSetLowQualityWebp: null,
          SizesAttribute:
            "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
          ImgSrc:
            "/contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
          ImgSrcLowQuality: null,
          AltText: "Unik möjlighet att etablera både labb och kontor",
        },
        Title: "Unik möjlighet att etablera både labb och kontor",
        SizeFrom: 474,
        SizeTo: 474,
        City: "Lund",
        District: "Ideon",
        PremiseType: ["Kontor"],
        Address: "Ideongatan 1A",
        SelectedFeatures: [
          { Description: "Elbilsplatser", Icon: "charge" },
          { Description: "Fiberanslutning", Icon: "fiber" },
          { Description: "Miljöcertifiering", Icon: "award" },
          { Description: "Mötesrum", Icon: "meeting" },
        ],
        OverflowFeaturesCount: 2,
        ChangedDate: "2025-12-03 10:50:21",
        Latitude: 55.7159771,
        Longitude: 13.2142795,
        TextRow: "",
        TextRow2: "",
      },
      {
        PricePerSqure: null,
        Url: "/sv/lediga-lokaler/lund/ideon/syret-8/4848-00307/",
        Image: {
          SrcSet:
            "/contentassets/bf2b8c25dc1a4c829a0228072c7d67d1/syret_8_240305_03.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/bf2b8c25dc1a4c829a0228072c7d67d1/syret_8_240305_03.jpg?width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetWebp:
            "/contentassets/bf2b8c25dc1a4c829a0228072c7d67d1/syret_8_240305_03.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/bf2b8c25dc1a4c829a0228072c7d67d1/syret_8_240305_03.jpg?format=webp&width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetLowQuality: null,
          SrcSetLowQualityWebp: null,
          SizesAttribute:
            "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
          ImgSrc:
            "/contentassets/bf2b8c25dc1a4c829a0228072c7d67d1/syret_8_240305_03.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
          ImgSrcLowQuality: null,
          AltText: "Rymlig lokal på bästa Ideonläge ",
        },
        Title: "Rymlig lokal på bästa Ideonläge ",
        SizeFrom: 360,
        SizeTo: 802,
        City: "Lund",
        District: "Ideon",
        PremiseType: ["Kontor"],
        Address: "Ideongatan 1A",
        SelectedFeatures: [
          { Description: "Elbilsplatser", Icon: "charge" },
          { Description: "Fiberanslutning", Icon: "fiber" },
          { Description: "Miljöcertifiering", Icon: "award" },
          { Description: "Mötesrum", Icon: "meeting" },
        ],
        OverflowFeaturesCount: 2,
        ChangedDate: "2025-08-11 08:47:22",
        Latitude: 55.7160134,
        Longitude: 13.2142949,
        TextRow: "",
        TextRow2: "",
      },
      {
        PricePerSqure: null,
        Url: "/sv/lediga-lokaler/lund/ideon/Zenit/zenit-0000-00001/",
        Image: {
          SrcSet:
            "/contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetWebp:
            "/contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w, /contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?format=webp&width=450&mode=crop&heightratio=0.7&quality=80 450w",
          SrcSetLowQuality: null,
          SrcSetLowQualityWebp: null,
          SizesAttribute:
            "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
          ImgSrc:
            "/contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
          ImgSrcLowQuality: null,
          AltText: "Zenit  - där arbetsro och energi strålar samman\n",
        },
        Title: "Zenit  - där arbetsro och energi strålar samman",
        SizeFrom: 690,
        SizeTo: 690,
        City: "Lund",
        District: "Ideon",
        PremiseType: ["Kontor", "Butik"],
        Address: "Ideongatan 1",
        SelectedFeatures: [
          { Description: "Balkong", Icon: "outdoor" },
          { Description: "Elbilsplatser", Icon: "charge" },
          { Description: "Fiberanslutning", Icon: "fiber" },
          { Description: "Gym", Icon: "gym" },
        ],
        OverflowFeaturesCount: 11,
        ChangedDate: "2025-02-05 11:43:23",
        Latitude: 55.7155997,
        Longitude: 13.2143427,
        TextRow: "",
        TextRow2: "",
      },
    ],
    TotalCount: 36,
    Sorting: {
      Label: "Sortera på",
      Options: [
        { Id: 1, Name: "Adress: A - Ö", Active: false },
        { Id: 2, Name: "Adress: Ö - A", Active: true },
        { Id: 3, Name: "Senaste objekt", Active: false },
        { Id: 4, Name: "Yta: minst", Active: false },
        { Id: 5, Name: "Yta: störst", Active: false },
      ],
    },
    Pagination: {
      display: 9,
      total: 36,
      currentPage: 1,
      pageCount: 4,
    },
  },
};

/**
 * Additional premises used to simulate extra pages.
 * These are variations/duplicates of the originals to fill out pages 2-4.
 */
var extraPremises = [
  {
    PricePerSqure: 1300,
    Url: "/sv/lediga-lokaler/malmo/centrum/stortorget-5/",
    Image: {
      SrcSet:
        "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Modernt kontor i Malmö Centrum",
    },
    Title: "Modernt kontor i Malmö Centrum",
    SizeFrom: 450,
    SizeTo: 900,
    City: "Malmö",
    District: "Centrum",
    PremiseType: ["Kontor"],
    Address: "Stortorget 5",
    SelectedFeatures: [
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Kök/pentry", Icon: "oven" },
      { Description: "Mötesrum", Icon: "meeting" },
      { Description: "Miljöcertifiering", Icon: "award" },
    ],
    OverflowFeaturesCount: 4,
    ChangedDate: "2025-12-10 09:00:00",
    Latitude: 55.6059,
    Longitude: 13.0007,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: 950,
    Url: "/sv/lediga-lokaler/malmo/hyllie/kontorsplats-1/",
    Image: {
      SrcSet:
        "/contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Flexibel kontorslokal i Hyllie",
    },
    Title: "Flexibel kontorslokal i Hyllie",
    SizeFrom: 200,
    SizeTo: 600,
    City: "Malmö",
    District: "Hyllie/Svågertorp",
    PremiseType: [
      "Kontor",
      "Kontorshotell",
      "Kontorshotell",
      "Kontorshotell",
      "Kontorshotell",
    ],
    Address: "Hyllie stationsväg 10",
    SelectedFeatures: [
      { Description: "Elbilsplatser", Icon: "charge" },
      { Description: "Gym", Icon: "gym" },
      { Description: "Cykelrum", Icon: "bike" },
      { Description: "Dusch", Icon: "shower" },
    ],
    OverflowFeaturesCount: 6,
    ChangedDate: "2025-10-15 14:30:00",
    Latitude: 55.5631,
    Longitude: 12.9775,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/helsingborg/centrum/norra-storgatan-12/",
    Image: {
      SrcSet:
        "/contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Butikslokal i Helsingborg Centrum",
    },
    Title: "Butikslokal i Helsingborg Centrum",
    SizeFrom: 120,
    SizeTo: 120,
    City: "Helsingborg",
    District: "Centrum",
    PremiseType: ["Butik"],
    Address: "Norra Storgatan 12",
    SelectedFeatures: [
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Närhet till buss", Icon: "bus" },
    ],
    OverflowFeaturesCount: 0,
    ChangedDate: "2025-09-20 10:00:00",
    Latitude: 56.0465,
    Longitude: 12.6945,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/lund/gastelyckan/lagerlokal-1/",
    Image: {
      SrcSet:
        "/contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Lagerlokal vid Gastelyckan",
    },
    Title: "Lagerlokal vid Gastelyckan",
    SizeFrom: 800,
    SizeTo: 1500,
    City: "Lund",
    District: "Gastelyckan",
    PremiseType: ["Lager"],
    Address: "Gastelyckan 7",
    SelectedFeatures: [
      { Description: "Elbilsplatser", Icon: "charge" },
      { Description: "Miljörum", Icon: "recycling" },
    ],
    OverflowFeaturesCount: 1,
    ChangedDate: "2025-06-01 08:00:00",
    Latitude: 55.7245,
    Longitude: 13.1678,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: 1100,
    Url: "/sv/lediga-lokaler/helsingborg/berga/industrilokal-1/",
    Image: {
      SrcSet:
        "/contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Industrilokal i Berga, Helsingborg",
    },
    Title: "Industrilokal i Berga, Helsingborg",
    SizeFrom: 1200,
    SizeTo: 1200,
    City: "Helsingborg",
    District: "Berga",
    PremiseType: ["Industri"],
    Address: "Berga Allé 3",
    SelectedFeatures: [
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Elbilsplatser", Icon: "charge" },
      { Description: "Miljörum", Icon: "recycling" },
    ],
    OverflowFeaturesCount: 2,
    ChangedDate: "2025-04-12 16:00:00",
    Latitude: 56.0711,
    Longitude: 12.7241,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/malmo/norra-sorgenfri/kontorslokal-1/",
    Image: {
      SrcSet:
        "/contentassets/bf2b8c25dc1a4c829a0228072c7d67d1/syret_8_240305_03.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/bf2b8c25dc1a4c829a0228072c7d67d1/syret_8_240305_03.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/bf2b8c25dc1a4c829a0228072c7d67d1/syret_8_240305_03.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Kreativ kontorslokal i Norra Sorgenfri",
    },
    Title: "Kreativ kontorslokal i Norra Sorgenfri",
    SizeFrom: 300,
    SizeTo: 500,
    City: "Malmö",
    District: "Norra Sorgenfri",
    PremiseType: ["Kontor"],
    Address: "Industrigatan 22",
    SelectedFeatures: [
      { Description: "Cykelrum", Icon: "bike" },
      { Description: "Dusch", Icon: "shower" },
      { Description: "Kök/pentry", Icon: "oven" },
    ],
    OverflowFeaturesCount: 3,
    ChangedDate: "2025-08-22 11:15:00",
    Latitude: 55.5941,
    Longitude: 13.0168,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/lund/lund-centrum/kontorshotell-1/",
    Image: {
      SrcSet:
        "/contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Kontorshotell mitt i Lund",
    },
    Title: "Kontorshotell mitt i Lund",
    SizeFrom: 15,
    SizeTo: 80,
    City: "Lund",
    District: "Lund centrum",
    PremiseType: ["Kontorshotell"],
    Address: "Kyrkogatan 4",
    SelectedFeatures: [
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Mötesrum", Icon: "meeting" },
      { Description: "Kök/pentry", Icon: "oven" },
      { Description: "Dusch", Icon: "shower" },
    ],
    OverflowFeaturesCount: 5,
    ChangedDate: "2025-11-18 13:45:00",
    Latitude: 55.7047,
    Longitude: 13.1911,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/helsingborg/langeberga/lager-1/",
    Image: {
      SrcSet:
        "/contentassets/917e0297ab8240e7b7dc932e1a020586/syret_9--7.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/917e0297ab8240e7b7dc932e1a020586/syret_9--7.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/917e0297ab8240e7b7dc932e1a020586/syret_9--7.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Lager- och logistikyta i Långeberga",
    },
    Title: "Lager- och logistikyta i Långeberga",
    SizeFrom: 1500,
    SizeTo: 3000,
    City: "Helsingborg",
    District: "Långeberga",
    PremiseType: ["Lager", "Industri"],
    Address: "Långebergavägen 8",
    SelectedFeatures: [
      { Description: "Elbilsplatser", Icon: "charge" },
      { Description: "Miljörum", Icon: "recycling" },
    ],
    OverflowFeaturesCount: 1,
    ChangedDate: "2025-03-28 07:30:00",
    Latitude: 56.0932,
    Longitude: 12.7617,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: 850,
    Url: "/sv/lediga-lokaler/malmo/limhamn/butik-1/",
    Image: {
      SrcSet:
        "/contentassets/60c2b2adc6d340df8fc7f1be7cb086ef/ideongatan_3a-20250515-09.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/60c2b2adc6d340df8fc7f1be7cb086ef/ideongatan_3a-20250515-09.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/60c2b2adc6d340df8fc7f1be7cb086ef/ideongatan_3a-20250515-09.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Charmig butik vid Limhamns Sjöstad",
    },
    Title: "Charmig butik vid Limhamns Sjöstad",
    SizeFrom: 75,
    SizeTo: 75,
    City: "Malmö",
    District: "Limhamn",
    PremiseType: ["Butik"],
    Address: "Limhamnsvägen 22",
    SelectedFeatures: [
      { Description: "Närhet till buss", Icon: "bus" },
      { Description: "Besöksparkering", Icon: "parking" },
    ],
    OverflowFeaturesCount: 0,
    ChangedDate: "2025-07-05 15:00:00",
    Latitude: 55.5831,
    Longitude: 12.9321,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/malmo/fosie/industri-1/",
    Image: {
      SrcSet:
        "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Industri- och lagerlokal i Fosie",
    },
    Title: "Industri- och lagerlokal i Fosie",
    SizeFrom: 950,
    SizeTo: 1800,
    City: "Malmö",
    District: "Fosie/Jägersro",
    PremiseType: ["Industri", "Lager"],
    Address: "Fosievägen 14",
    SelectedFeatures: [
      { Description: "Elbilsplatser", Icon: "charge" },
      { Description: "Miljörum", Icon: "recycling" },
      { Description: "Fiberanslutning", Icon: "fiber" },
    ],
    OverflowFeaturesCount: 1,
    ChangedDate: "2025-05-10 12:00:00",
    Latitude: 55.5658,
    Longitude: 13.0254,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: 1450,
    Url: "/sv/lediga-lokaler/malmo/vastra-hamnen/kontor-1/",
    Image: {
      SrcSet:
        "/contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Sjönära kontor i Västra Hamnen",
    },
    Title: "Sjönära kontor i Västra Hamnen",
    SizeFrom: 350,
    SizeTo: 720,
    City: "Malmö",
    District: "Västra hamnen",
    PremiseType: ["Kontor"],
    Address: "Turning Torso 15",
    SelectedFeatures: [
      { Description: "Balkong", Icon: "outdoor" },
      { Description: "Gym", Icon: "gym" },
      { Description: "Dusch", Icon: "shower" },
      { Description: "Cykelrum", Icon: "bike" },
    ],
    OverflowFeaturesCount: 7,
    ChangedDate: "2026-01-05 09:30:00",
    Latitude: 55.6135,
    Longitude: 12.9752,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/helsingborg/sodra/kontor-1/",
    Image: {
      SrcSet:
        "/contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Kontorslokal i södra Helsingborg",
    },
    Title: "Kontorslokal i södra Helsingborg",
    SizeFrom: 520,
    SizeTo: 520,
    City: "Helsingborg",
    District: "Södra",
    PremiseType: ["Kontor"],
    Address: "Södra Stenbocksgatan 8",
    SelectedFeatures: [
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Kök/pentry", Icon: "oven" },
      { Description: "Mötesrum", Icon: "meeting" },
    ],
    OverflowFeaturesCount: 2,
    ChangedDate: "2025-09-14 10:45:00",
    Latitude: 56.0312,
    Longitude: 12.7012,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/lund/vaster/kontor-1/",
    Image: {
      SrcSet:
        "/contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Trivsamt kontor i Lund Väster",
    },
    Title: "Trivsamt kontor i Lund Väster",
    SizeFrom: 180,
    SizeTo: 340,
    City: "Lund",
    District: "Väster",
    PremiseType: ["Kontor"],
    Address: "Clemenstorget 2",
    SelectedFeatures: [
      { Description: "Cykelrum", Icon: "bike" },
      { Description: "Dusch", Icon: "shower" },
      { Description: "Kök/pentry", Icon: "oven" },
    ],
    OverflowFeaturesCount: 4,
    ChangedDate: "2025-10-30 08:20:00",
    Latitude: 55.7032,
    Longitude: 13.1823,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/malmo/nyhamnen/tomt-1/",
    Image: {
      SrcSet:
        "/contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Tomt för nybyggnation i Nyhamnen",
    },
    Title: "Tomt för nybyggnation i Nyhamnen",
    SizeFrom: 2000,
    SizeTo: 5000,
    City: "Malmö",
    District: "Nyhamnen",
    PremiseType: ["Tomt/Nybyggnation"],
    Address: "Nyhamnsvägen 1",
    SelectedFeatures: [],
    OverflowFeaturesCount: 0,
    ChangedDate: "2025-01-15 16:00:00",
    Latitude: 55.6185,
    Longitude: 13.0025,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: 1200,
    Url: "/sv/lediga-lokaler/helsingborg/vala/kontor-1/",
    Image: {
      SrcSet:
        "/contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Kontor nära Väla köpcentrum",
    },
    Title: "Kontor nära Väla köpcentrum",
    SizeFrom: 400,
    SizeTo: 850,
    City: "Helsingborg",
    District: "Väla södra / Väla norra",
    PremiseType: ["Kontor"],
    Address: "Väla Norra 5",
    SelectedFeatures: [
      { Description: "Besöksparkering", Icon: "parking" },
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Mötesrum", Icon: "meeting" },
      { Description: "Gym", Icon: "gym" },
    ],
    OverflowFeaturesCount: 3,
    ChangedDate: "2025-12-20 14:00:00",
    Latitude: 56.0865,
    Longitude: 12.7412,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/lund/rabyholm/lager-1/",
    Image: {
      SrcSet:
        "/contentassets/bf2b8c25dc1a4c829a0228072c7d67d1/syret_8_240305_03.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/bf2b8c25dc1a4c829a0228072c7d67d1/syret_8_240305_03.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/bf2b8c25dc1a4c829a0228072c7d67d1/syret_8_240305_03.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Lagerlokal i Råbyholm, Lund",
    },
    Title: "Lagerlokal i Råbyholm, Lund",
    SizeFrom: 600,
    SizeTo: 1200,
    City: "Lund",
    District: "Råbyholm",
    PremiseType: ["Lager"],
    Address: "Råbyholmsvägen 18",
    SelectedFeatures: [
      { Description: "Elbilsplatser", Icon: "charge" },
      { Description: "Miljörum", Icon: "recycling" },
    ],
    OverflowFeaturesCount: 0,
    ChangedDate: "2025-04-22 09:15:00",
    Latitude: 55.7156,
    Longitude: 13.2345,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/helsingborg/attekulla/industri-1/",
    Image: {
      SrcSet:
        "/contentassets/917e0297ab8240e7b7dc932e1a020586/syret_9--7.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/917e0297ab8240e7b7dc932e1a020586/syret_9--7.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/917e0297ab8240e7b7dc932e1a020586/syret_9--7.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Industrilokal i Ättekulla",
    },
    Title: "Industrilokal i Ättekulla",
    SizeFrom: 1000,
    SizeTo: 2500,
    City: "Helsingborg",
    District: "Ättekulla",
    PremiseType: ["Industri"],
    Address: "Ättekullsvägen 4",
    SelectedFeatures: [
      { Description: "Elbilsplatser", Icon: "charge" },
      { Description: "Fiberanslutning", Icon: "fiber" },
    ],
    OverflowFeaturesCount: 1,
    ChangedDate: "2025-02-28 07:00:00",
    Latitude: 56.0398,
    Longitude: 12.7345,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/malmo/burlov/kontor-1/",
    Image: {
      SrcSet:
        "/contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/e6d06410f6564c3eb4421286d15e3760/exterior_-_werket_utan_wihlborgslogo.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Kontorslokal vid Stora Bernstorp",
    },
    Title: "Kontorslokal vid Stora Bernstorp",
    SizeFrom: 250,
    SizeTo: 480,
    City: "Malmö",
    District: "Burlöv/Stora Bernstorp",
    PremiseType: ["Kontor"],
    Address: "Bernstorpsvägen 12",
    SelectedFeatures: [
      { Description: "Besöksparkering", Icon: "parking" },
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Kök/pentry", Icon: "oven" },
    ],
    OverflowFeaturesCount: 2,
    ChangedDate: "2025-06-18 11:30:00",
    Latitude: 55.6312,
    Longitude: 13.0756,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: 1050,
    Url: "/sv/lediga-lokaler/lund/science-village/kontor-1/",
    Image: {
      SrcSet:
        "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Framtidens kontor i Science Village",
    },
    Title: "Framtidens kontor i Science Village",
    SizeFrom: 500,
    SizeTo: 1100,
    City: "Lund",
    District: "Science Village",
    PremiseType: ["Kontor"],
    Address: "Science Village 1",
    SelectedFeatures: [
      { Description: "Miljöcertifiering", Icon: "award" },
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Elbilsplatser", Icon: "charge" },
      { Description: "Gym", Icon: "gym" },
    ],
    OverflowFeaturesCount: 8,
    ChangedDate: "2026-01-10 10:00:00",
    Latitude: 55.7312,
    Longitude: 13.2245,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/helsingborg/landskrona/kontor-1/",
    Image: {
      SrcSet:
        "/contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/bffde0c434694749a8070f3ff6858265/isbergs_gata_13-20250701-15.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Kontor i centrala Landskrona",
    },
    Title: "Kontor i centrala Landskrona",
    SizeFrom: 200,
    SizeTo: 450,
    City: "Helsingborg",
    District: "Landskrona",
    PremiseType: ["Kontor"],
    Address: "Storgatan 20, Landskrona",
    SelectedFeatures: [
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Kök/pentry", Icon: "oven" },
      { Description: "Närhet till buss", Icon: "bus" },
    ],
    OverflowFeaturesCount: 1,
    ChangedDate: "2025-08-05 13:00:00",
    Latitude: 55.8709,
    Longitude: 12.8301,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/malmo/medeon/kontor-1/",
    Image: {
      SrcSet:
        "/contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/5dc3b8b680c848c68471fc5d7d4b5028/syret_8--4.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Kontor i Medeon Science Park",
    },
    Title: "Kontor i Medeon Science Park",
    SizeFrom: 280,
    SizeTo: 560,
    City: "Malmö",
    District: "Medeon",
    PremiseType: ["Kontor"],
    Address: "Per Albin Hanssons väg 41",
    SelectedFeatures: [
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Miljöcertifiering", Icon: "award" },
      { Description: "Elbilsplatser", Icon: "charge" },
    ],
    OverflowFeaturesCount: 4,
    ChangedDate: "2025-11-25 09:00:00",
    Latitude: 55.5712,
    Longitude: 13.0312,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: 900,
    Url: "/sv/lediga-lokaler/malmo/dockan/kontor-extra-1/",
    Image: {
      SrcSet:
        "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/787f010028c54aba8661ac3b6eeb1bda/exterior_-_werket_utan_wihlborgslogo2.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Ytterligare kontorslokal vid Dockan",
    },
    Title: "Ytterligare kontorslokal vid Dockan",
    SizeFrom: 380,
    SizeTo: 380,
    City: "Malmö",
    District: "Dockan/Varvsstaden",
    PremiseType: ["Kontor"],
    Address: "Dockplatsen 1",
    SelectedFeatures: [
      { Description: "Balkong", Icon: "outdoor" },
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Gym", Icon: "gym" },
      { Description: "Dusch", Icon: "shower" },
    ],
    OverflowFeaturesCount: 5,
    ChangedDate: "2025-12-15 10:00:00",
    Latitude: 55.6135,
    Longitude: 12.9905,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/lund/ideon/kontor-extra-1/",
    Image: {
      SrcSet:
        "/contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/07f7b91df2b04dd4a9303b50ee03acab/_n4a66072.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Ideon Gateway - kontorslokal med utsikt",
    },
    Title: "Ideon Gateway - kontorslokal med utsikt",
    SizeFrom: 550,
    SizeTo: 1050,
    City: "Lund",
    District: "Ideon",
    PremiseType: ["Kontor"],
    Address: "Scheelevägen 15",
    SelectedFeatures: [
      { Description: "Balkong", Icon: "outdoor" },
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Gym", Icon: "gym" },
      { Description: "Miljöcertifiering", Icon: "award" },
    ],
    OverflowFeaturesCount: 9,
    ChangedDate: "2026-02-01 08:30:00",
    Latitude: 55.7168,
    Longitude: 13.2125,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: 780,
    Url: "/sv/lediga-lokaler/helsingborg/centrum/butik-extra-1/",
    Image: {
      SrcSet:
        "/contentassets/60c2b2adc6d340df8fc7f1be7cb086ef/ideongatan_3a-20250515-09.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/60c2b2adc6d340df8fc7f1be7cb086ef/ideongatan_3a-20250515-09.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/60c2b2adc6d340df8fc7f1be7cb086ef/ideongatan_3a-20250515-09.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Butik på Kullagatan, Helsingborg",
    },
    Title: "Butik på Kullagatan, Helsingborg",
    SizeFrom: 95,
    SizeTo: 95,
    City: "Helsingborg",
    District: "Centrum",
    PremiseType: ["Butik"],
    Address: "Kullagatan 12",
    SelectedFeatures: [
      { Description: "Närhet till buss", Icon: "bus" },
      { Description: "Fiberanslutning", Icon: "fiber" },
    ],
    OverflowFeaturesCount: 0,
    ChangedDate: "2025-07-28 14:30:00",
    Latitude: 56.0472,
    Longitude: 12.6941,
    TextRow: "",
    TextRow2: "",
  },
  {
    PricePerSqure: null,
    Url: "/sv/lediga-lokaler/malmo/centrum/kontor-extra-1/",
    Image: {
      SrcSet:
        "/contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetWebp:
        "/contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?format=webp&width=350&mode=crop&heightratio=0.7&quality=80 350w",
      SrcSetLowQuality: null,
      SrcSetLowQualityWebp: null,
      SizesAttribute:
        "(max-width: 767px) 100vw, (max-width: 991px) 50vw, 300px",
      ImgSrc:
        "/contentassets/72c7ed40b06c4a6a8b640644eb0978cf/syret_8--5.jpg?width=350&mode=crop&heightratio=0.7&quality=80",
      ImgSrcLowQuality: null,
      AltText: "Central kontorslokal nära Malmö C",
    },
    Title: "Central kontorslokal nära Malmö C",
    SizeFrom: 320,
    SizeTo: 640,
    City: "Malmö",
    District: "Centrum",
    PremiseType: ["Kontor"],
    Address: "Carlsgatan 1",
    SelectedFeatures: [
      { Description: "Fiberanslutning", Icon: "fiber" },
      { Description: "Närhet till buss", Icon: "bus" },
      { Description: "Mötesrum", Icon: "meeting" },
      { Description: "Kök/pentry", Icon: "oven" },
    ],
    OverflowFeaturesCount: 5,
    ChangedDate: "2025-10-02 11:00:00",
    Latitude: 55.6092,
    Longitude: 13.0002,
    TextRow: "",
    TextRow2: "",
  },
];

/**
 * Build a complete lookup of district IDs to their city/district names
 * from the filters structure.
 */
function buildDistrictLookup(filters) {
  var lookup = {};
  var locationFilter = filters.find(function (f) {
    return (f.Name || "").toLowerCase() === "location";
  });
  if (!locationFilter || !locationFilter.Items) return lookup;

  locationFilter.Items.forEach(function (city) {
    var cityId = city.Id;
    var cityName = city.Name;
    // Store city-level lookup
    lookup["city_" + cityId] = {
      cityName: cityName,
      districts: (city.Districts || []).map(function (d) {
        return d.Name;
      }),
    };
    // Store district-level lookup
    (city.Districts || []).forEach(function (d) {
      lookup["district_" + d.Id] = {
        cityName: cityName,
        districtName: d.Name,
      };
    });
  });

  return lookup;
}

/**
 * Simulate the server-side POST API behavior:
 * - Filters premises by location, district, premisetype, area
 * - Sorts by the selected sorting option
 * - Paginates (9 items per page)
 * - Returns the correct response shape including updated filter Active flags
 *
 * @param {Object} payload - The POST request payload
 * @param {number} payload.page - Page number (1-based)
 * @param {number} [payload.sort] - Sorting option ID
 * @param {string[]} [payload.cityIds] - Array of city IDs to filter
 * @param {string[]} [payload.districtIds] - Array of district IDs to filter
 * @param {string[]} [payload.type] - Array of premise type names to filter
 * @param {number} [payload.areaMin] - Minimum area filter
 * @param {number} [payload.areaMax] - Maximum area filter
 * @returns {Object} Response in the same shape as the real server API
 */
function simulatePostResponse(payload) {
  var PAGE_SIZE = (payload && payload.limit) || 9;
  var page = (payload && payload.page) || 1;
  var sortingId = (payload && payload.sort) || 2;
  var locationIds = (payload && payload.cityIds) || [];
  var districtIds = (payload && payload.districtIds) || [];
  var premiseTypes = (payload && (payload.types || payload.type)) || [];
  var areaMin =
    payload && payload.areaMin !== undefined ? payload.areaMin : null;
  var areaMax =
    payload && payload.areaMax !== undefined ? payload.areaMax : null;
  var minWorkplaces =
    payload && payload.minNumberOfWorkplaces !== undefined
      ? payload.minNumberOfWorkplaces
      : null;
  var maxWorkplaces =
    payload && payload.maxNumberOfWorkplaces !== undefined
      ? payload.maxNumberOfWorkplaces
      : null;

  // Combine all premises (original 9 + extras) to create a full dataset
  var allPremises = mockPremisesData.Premises.Premises.concat(extraPremises);

  var filters = mockPremisesData.Premises.PremisesFilters;
  var districtLookup = buildDistrictLookup(filters);

  // ---- FILTERING ----
  var filtered = allPremises;

  // Filter by city (location IDs)
  if (locationIds.length > 0) {
    var allowedCityNames = [];
    locationIds.forEach(function (cityId) {
      var info = districtLookup["city_" + cityId];
      if (info) {
        allowedCityNames.push(info.cityName);
      }
    });

    if (allowedCityNames.length > 0) {
      filtered = filtered.filter(function (p) {
        return allowedCityNames.indexOf(p.City) !== -1;
      });
    }
  }

  // Filter by district IDs
  if (districtIds.length > 0) {
    var allowedDistrictNames = [];
    districtIds.forEach(function (districtId) {
      var info = districtLookup["district_" + districtId];
      if (info) {
        allowedDistrictNames.push(info.districtName);
      }
    });

    if (allowedDistrictNames.length > 0) {
      filtered = filtered.filter(function (p) {
        return allowedDistrictNames.indexOf(p.District) !== -1;
      });
    }
  }

  // Filter by premise type
  if (premiseTypes.length > 0) {
    var lowerTypes = premiseTypes.map(function (t) {
      return t.toLowerCase();
    });
    filtered = filtered.filter(function (p) {
      return p.PremiseType.some(function (pt) {
        return lowerTypes.indexOf(pt.toLowerCase()) !== -1;
      });
    });
  }

  // Filter by area range
  if (areaMin !== null && !isNaN(areaMin)) {
    filtered = filtered.filter(function (p) {
      return p.SizeTo >= areaMin || p.SizeFrom >= areaMin;
    });
  }
  if (areaMax !== null && !isNaN(areaMax) && areaMax > 0) {
    filtered = filtered.filter(function (p) {
      return p.SizeFrom <= areaMax;
    });
  }

  // Filter by number of workplaces
  if (minWorkplaces !== null && !isNaN(minWorkplaces)) {
    filtered = filtered.filter(function (p) {
      return (
        p.maxNumberOfWorkplaces >= minWorkplaces ||
        p.numberOfWorkplaces >= minWorkplaces
      );
    });
  }
  if (maxWorkplaces !== null && !isNaN(maxWorkplaces) && maxWorkplaces > 0) {
    filtered = filtered.filter(function (p) {
      return (
        p.minNumberOfWorkplaces <= maxWorkplaces ||
        p.numberOfWorkplaces <= maxWorkplaces
      );
    });
  }

  // ---- SORTING ----
  var sorted = filtered.slice();
  switch (sortingId) {
    case 1: // Adress A-Ö
      sorted.sort(function (a, b) {
        return (a.Address || "").localeCompare(b.Address || "", "sv");
      });
      break;
    case 2: // Adress Ö-A
      sorted.sort(function (a, b) {
        return (b.Address || "").localeCompare(a.Address || "", "sv");
      });
      break;
    case 3: // Senaste objekt
      sorted.sort(function (a, b) {
        return (b.ChangedDate || "").localeCompare(a.ChangedDate || "");
      });
      break;
    case 4: // Yta: minst
      sorted.sort(function (a, b) {
        return (a.SizeFrom || 0) - (b.SizeFrom || 0);
      });
      break;
    case 5: // Yta: störst
      sorted.sort(function (a, b) {
        return (b.SizeTo || 0) - (a.SizeTo || 0);
      });
      break;
    default:
      // Default: senaste objekt
      sorted.sort(function (a, b) {
        return (b.ChangedDate || "").localeCompare(a.ChangedDate || "");
      });
  }

  // ---- PAGINATION ----
  var totalCount = sorted.length;

  // When limit >= 999, skip pagination and return all results
  if (payload.limit && payload.limit === 999) {
    const mapResponse = {
      Premises: {
        PremisesFilters: responseFilters,
        Premises:sorted,
        TotalCount: totalCount,
        Sorting: sortingResponse,
        Pagination: {
          display: totalCount,
          total: totalCount,
          currentPage: 1,
          pageCount: 1,
        },
      },
    };

    return mapResponse;
  }

  var pageCount = Math.ceil(totalCount / PAGE_SIZE);
  var clampedPage = Math.max(1, Math.min(page, pageCount || 1));
  var startIndex = (clampedPage - 1) * PAGE_SIZE;
  var endIndex = Math.min(startIndex + PAGE_SIZE, totalCount);
  var pagePremises = sorted.slice(startIndex, endIndex);

  // ---- BUILD FILTER RESPONSE WITH ACTIVE FLAGS ----
  // Deep clone filters and set Active flags based on current filter selections
  var responseFilters = JSON.parse(JSON.stringify(filters));

  responseFilters.forEach(function (filter) {
    var filterName = (filter.Name || "").toLowerCase();
    if (filterName === "location" && filter.Items) {
      filter.Items.forEach(function (city) {
        // Set city active based on locationIds
        city.Active = locationIds.indexOf(Number(city.Id)) !== -1;

        if (city.Districts) {
          city.Districts.forEach(function (district) {
            // If city is active, mark all districts active
            if (city.Active) {
              district.Active = true;
            } else {
              // Otherwise, check districtIds individually
              district.Active = districtIds.indexOf(Number(district.Id)) !== -1;
            }
          });
        }
      });
    }
  });

  // ---- BUILD SORTING RESPONSE ----
  var sortingResponse = {
    Label: "Sortera på",
    Options: [
      { Id: 1, Name: "Adress: A - Ö", Active: sortingId === 1 },
      { Id: 2, Name: "Adress: Ö - A", Active: sortingId === 2 },
      { Id: 3, Name: "Senaste objekt", Active: sortingId === 3 },
      { Id: 4, Name: "Yta: minst", Active: sortingId === 4 },
      { Id: 5, Name: "Yta: störst", Active: sortingId === 5 },
    ],
  };

  // ---- BUILD RESPONSE ----
  return {
    Premises: {
      PremisesFilters: responseFilters,
      Premises: pagePremises,
      TotalCount: totalCount,
      Sorting: sortingResponse,
      Pagination: {
        display: pagePremises.length,
        total: totalCount,
        currentPage: clampedPage,
        pageCount: pageCount,
      },
    },
  };
}

export { mockPremisesData, simulatePostResponse };
export default mockPremisesData;
